// store.js
import { createStore } from 'vuex';

const store = createStore({
  state: {
    user: null,
    isAuthenticated: !!localStorage.getItem('jwt')
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      state.isAuthenticated = !!user;
    },
    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
    }
  },
  actions: {
    setUser({ commit }, user) {
      commit('setUser', user);
    },
    logout({ commit }) {
      commit('logout');
      localStorage.removeItem('jwt');
      localStorage.removeItem('jwt_issued_at');
    }
  },
  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    user: (state) => state.user
  }
});

export default store;
